import { RefuseAppointmentOnCall } from '~/domain/usecases/onCall/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteRefuseAppointmentOnCall implements RefuseAppointmentOnCall {
  private readonly url: string;

  private readonly httpClient: HttpClient<RefuseAppointmentOnCall.Model>;

  constructor(
    url: string,
    httClient: HttpClient<RefuseAppointmentOnCall.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  refuseAppointment = async (
    params: RefuseAppointmentOnCall.Params,
  ): Promise<RefuseAppointmentOnCall.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', params.onCallId.toString())
        .replace('{specialistId}', params.specialistId.toString())
        .replace('{requesterId}', params.requesterId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
